import React from 'react'
import './styles.css'

const Content = () => {
    return (
        <div className="content">
            <div className="title"><a href="/about">Raunak Kesarwani</a></div>
            <div className="description">
                <p>Full-Stack Developer | AI/ML enthusiast </p>
                <p>Passionate about building modern web applications and intelligent software solutions. </p>
            </div>
        </div>
    )
}

export default Content